<div [formGroup]="formGroup">
  @for (elt of ar; track elt.id; let j = $index) {
    <div class='left-header-cell' [ngStyle]="elt.style">
        @if (elt.isElligible | CheckEligiblePipe) {
          <div style="margin-right: 9px;margin-left: 23px;">
              @if (elt.checkbox) {
                <mat-checkbox (change)="check($event['checked'], elt.id)"
                              [formControlName]="elt.id"></mat-checkbox>
              }
          </div>
        } @else {
          <div style="margin-right: 9px;margin-left: 23px;width: 16px"></div>
        }
        <div style="position: relative;line-height: 16px">
            <div style="font-size: 16px;font-weight: 800;">{{elt.header}}</div>
            <div style="font-size: 16px;font-weight: 800;">{{elt.header2}}</div>
            <div style="font-size: 12px;font-weight: normal;">
                {{elt.subtitle}}
            </div>
            @if (elt.italic) {
              <div style="color: #757980;font-style: italic;font-size: 10px;" [innerHTML]="elt.italic | sanitizeHtml"></div>
            }
        </div>
    </div>
    }
    <div class="left-header-cell" style="justify-content: center; text-align: center;background-color: #EEEEEE;font-weight: 800">
        Mensualité à partir de :
    </div>
</div>

